document.addEventListener('DOMContentLoaded', () => {
  const pushClickEvent = (imageAlt, imagePlacement) => {
    window?._paq?.push(['trackEvent', trackingLabel(imagePlacement), 'Click', imageAlt]);

    try {
      gtag('event', 'click_custom_event', {
        event_name: (trackingLabel(imagePlacement) + '/' + imageAlt)
      });
    } catch(e) {
      console.log('not defined gtag')
    }
  };

  const pushViewEvent = (imageAlt, imagePlacement) => {
    window?._paq?.push(['trackEvent', trackingLabel(imagePlacement), 'View', imageAlt]);

    try {
      gtag('event', 'view_custom_event', {
        event_name: (trackingLabel(imagePlacement) + '/' + imageAlt)
      });
    } catch(e) {
      console.log('not defined gtag')
    }
  };

  const trackingLabel = (imagePlacement) => {
    const prefix = window.jishaConfig.SITE_TYPE === 'association' ? 'organization' : 'default'
    return `${prefix}-${imagePlacement}`;
  }

  Array.from(document.getElementsByClassName('js-matomo-tracking')).forEach((element) => {
    const image = element.firstElementChild
    if (image === null || image.tagName !== 'IMG') {
      return;
    }

    const imagePlacement = image.dataset.imagePlacement;
    if (!imagePlacement) return;

    pushViewEvent(image.alt, imagePlacement);

    element.addEventListener('click', () => {
      pushClickEvent(image.alt, imagePlacement);
    });
  });
});
